module.exports = __webpack_public_path__ + "img/foto.aaa013aa.png";